export const DIFFICULTY_ALL = "all";
export const DIFFICULTY_VALUES = [1, 2, 3];
export const DEFAULT_DIFFICULTY_VALUE = 2;

export const isDifficultyAll = (value) =>
  value === DIFFICULTY_ALL || value === null || value === undefined;

export const normalizeDifficultyFilterValue = (value) => {
  if (isDifficultyAll(value)) return DIFFICULTY_ALL;
  const numeric = Number(value);
  return DIFFICULTY_VALUES.includes(numeric) ? numeric : DIFFICULTY_ALL;
};

export const resolveDifficultyValue = (
  value,
  fallback = DEFAULT_DIFFICULTY_VALUE,
) => {
  const numeric = Number(value);
  return DIFFICULTY_VALUES.includes(numeric) ? numeric : fallback;
};
